<template>
    <div>
        <!-- FASE 4 / BLOCO AA — DOC 1, 3, 22, 26, 83: criação do documento -->

        <el-form @submit.native.prevent="salvar" :model="dados" ref="dados" label-position="top">

            <el-row :gutter="10">
                <el-col :xs="24" :sm="18" :md="18">
                    <el-form-item label="Título" prop="titulo" :rules="[$requiredBlur]" key="titulo">
                        <el-input v-model="dados.titulo" maxlength="255"
                                  placeholder="Ex.: Portaria 12/2026 — designação"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="6" :md="6">
                    <el-form-item label="Pasta">
                        <el-select v-model="dados.pasta_id" placeholder="/ (raiz)" style="width:100%" clearable>
                            <el-option v-for="p in pastas" :key="p.id" :label="p.caminho" :value="p.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <!--
                    Salvando na raiz, o backend precisa saber a instituição — e perfil de rede
                    não tem escola no contexto do header. Sem este campo, `instituicao_id` ia
                    nulo e o `store` respondia 403 "Informe a instituição em que o documento
                    será criado", sem lugar nenhum onde informá-la.
                -->
                <el-col :xs="24" :sm="6" :md="6" v-if="ehRede && !dados.pasta_id">
                    <el-form-item label="Instituição">
                        <el-select v-model="dados.instituicao_id" filterable clearable
                                   placeholder="Selecione a instituição" style="width:100%">
                            <el-option v-for="i in instituicoes" :key="i.id" :label="i.nome" :value="i.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row :gutter="10">
                <el-col :xs="24">
                    <el-form-item label="Descrição">
                        <el-input v-model="dados.descricao" type="textarea" :rows="2" maxlength="2000"
                                  placeholder="Resumo do documento (opcional)"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row :gutter="10">
                <el-col :xs="24">
                    <el-form-item label="Conteúdo do documento">
                        <ckeditor v-model="dados.conteudo"></ckeditor>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row :gutter="10">
                <el-col :xs="24">
                    <el-form-item label="Arquivos (opcional)">
                        <el-upload
                            class="area-arrastar"
                            drag multiple action=""
                            :auto-upload="false"
                            :file-list="listaArquivos"
                            :on-change="aoMudarLista"
                            :on-remove="aoMudarLista">
                            <i class="el-icon-upload"></i>
                            <div class="el-upload__text">
                                Arraste arquivos aqui ou <em>clique para selecionar</em>
                            </div>
                            <div class="el-upload__tip" slot="tip">
                                Vários arquivos de uma vez. Cada um vira uma versão do documento.
                            </div>
                        </el-upload>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row :gutter="10">
                <el-col :xs="24">
                    <el-form-item class="u-text-right u-mt-15">
                        <el-button type="default" @click="$router.push('/admin/documento')">CANCELAR</el-button>
                        <el-button class="u-ml-10" type="primary" id="btn-documento" native-type="submit">SALVAR</el-button>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>
<script>

import ckeditor from '@/shared/ckeditor/ckeditor'

export default {
    data: () => ({
        dados: { titulo: '', descricao: '', conteudo: '', pasta_id: null, instituicao_id: null },
        instituicoes: [],
        pastas: [],
        listaArquivos: []
    }),
    computed: {
        /** Perfis de abrangência de rede — os que não têm escola no contexto do header. */
        ehRede () {
            const t = parseInt(this.$store.state.user ? this.$store.state.user.tipo : null)
            return t === 10 || (t > 3 && t <= 8)
        }
    },
    mounted () {
        this.carregarPastas()
        if (this.ehRede) this.carregarInstituicoes()
    },
    methods: {
        base () { return this.$store.state.config.baseUrlApi },
        auth () { return this.$store.getters.getHeaderAuth },

        carregarInstituicoes () {
            this.$axios.get(`${this.base()}/api/instituicao/getAll`, this.auth())
                .then(r => { this.instituicoes = Array.isArray(r.data) ? r.data : Object.values(r.data || {}) })
                .catch(() => { this.instituicoes = [] })
        },

        /** A escola escolhida na tela tem precedência sobre a do contexto. */
        instituicaoAtual () {
            if (this.dados.instituicao_id) return this.dados.instituicao_id
            const i = this.$store.state.config.instituicao
            return i ? i.id : null
        },

        erro (e) {
            window.eventBus.$emit('loading', false)
            const resp = e && e.response ? e.response.data : null
            let msg = 'Não foi possível concluir a operação.'
            if (resp && typeof resp.erro === 'string') msg = resp.erro
            else if (resp && resp.erro && resp.erro.text) msg = resp.erro.text
            window.eventBus.$emit('alert', { msg: msg, type: 'error' })
            this.$store.commit('throwException', e)
        },

        carregarPastas () {
            this.$axios.post(`${this.base()}/api/documento-pasta/arvore`, {}, this.auth()).then(r => {
                this.pastas = this.achatar(r.data)
            }).catch(e => { this.erro(e) })
        },

        achatar (nos, acc) {
            acc = acc || []
            nos.forEach(n => { acc.push(n); if (n.filhas && n.filhas.length) this.achatar(n.filhas, acc) })
            return acc
        },

        aoMudarLista (file, fileList) { this.listaArquivos = fileList },

        salvar () {
            this.$refs.dados.validate(valido => {
                if (!valido) return

                const payload = {
                    titulo: this.dados.titulo,
                    descricao: this.dados.descricao,
                    conteudo: this.dados.conteudo
                }

                if (this.dados.pasta_id) {
                    payload.pasta_id = this.dados.pasta_id
                } else {
                    payload.instituicao_id = this.instituicaoAtual()

                    if (!payload.instituicao_id) {
                        return window.eventBus.$emit('alert', {
                            msg: 'Selecione a instituição ou escolha uma pasta antes de salvar.',
                            type: 'warning'
                        })
                    }
                }

                window.eventBus.$emit('loading', true)

                this.$axios.post(`${this.base()}/api/documento/store`, payload, this.auth()).then(r => {
                    const id = r.data.id

                    if (!this.listaArquivos.length) {
                        window.eventBus.$emit('loading', false)
                        window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
                        this.$router.push('/admin/documento/detalhe/' + id)
                        return
                    }

                    const form = new FormData()
                    this.listaArquivos.forEach(f => { if (f.raw) form.append('arquivos[]', f.raw) })

                    const cfg = Object.assign({}, this.auth())
                    cfg.headers = Object.assign({}, cfg.headers, { 'Content-Type': 'multipart/form-data' })

                    this.$axios.post(`${this.base()}/api/documento/versao-enviar/${id}`, form, cfg).then(() => {
                        window.eventBus.$emit('loading', false)
                        window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
                        this.$router.push('/admin/documento/detalhe/' + id)
                    }).catch(e => {
                        // O documento foi criado; só o anexo falhou. Levar o usuário até ele
                        // é melhor do que deixá-lo no formulário achando que perdeu tudo.
                        this.erro(e)
                        this.$router.push('/admin/documento/detalhe/' + id)
                    })
                }).catch(e => { this.erro(e) })
            })
        }
    },
    components: { ckeditor }
}
</script>
<style scoped>
.area-arrastar >>> .el-upload, .area-arrastar >>> .el-upload-dragger { width: 100%; }
</style>
